// extracted by mini-css-extract-plugin
export default {"apiKeyDocLink":"src-feature-marketplace-integration-api-key-__api-keys_apiKeyDocLink"};